<template>
    <div class="etr">
    <b-card class="mt-3">
      <b-card-header v-if="data ">
        <b-row align-v="center" no-gutters>
          <b-col cols="8">
            <b-button-group>
              <!-- <b-button
                v-print="'#paper'"
                squared
                size="sm"
                class="mr-4"
                title="Print"
              >
                <i class="fa fa-print pr-3"></i>Print
              </b-button> -->
              <div class="inline-block">
                <i
                  :class="
                    data.credit
                      ? 'fa fa-gbp fa-2x mr-1 text-danger'
                      : 'fa fa-gbp fa-2x mr-1 text-primary'
                  "
                ></i>
                <span class="h4 ml-1">{{ data.ref }}</span>
              </div>
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
    
      <r-invoice :invoiceno="selection[0].invoiceno" />

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button
              squared
              size="sm"
              variant="secondary"
              @click="$emit('discard')"
            >
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>

</template>
    
<script>
export default {
  name: "OrderInvoice",
};
</script>
    
<style>
</style>
    